<div class="modal-header">
    <h4 class="modal-title">{{ title | translate }}</h4>
    <div>
        <i class="fe fe-x black-menu" ngbTooltip="{{ 'Close' | translate }}" (click)="onCancel()"
            [class.pe-none]="loadingKey && httpService.getLoading(loadingKey)"></i>
    </div>
</div>
<div class="modal-body">
    {{ message | translate }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-light" (click)="onCancel()"
        [disabled]="loadingKey && httpService.getLoading(loadingKey)">
        <i class="fe fe-x"></i>
        <span>{{ cancelText | translate }}</span>
    </button>
    <button type="button" class="btn btn-sm btn-primary" (click)="onConfirm()"
        [disabled]="loadingKey && httpService.getLoading(loadingKey)">
        <ng-container *ngIf="loadingKey && httpService.getLoading(loadingKey)">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            <span>{{ 'Saving' | translate }} ...</span>
        </ng-container>
        <ng-container *ngIf="!(loadingKey && httpService.getLoading(loadingKey))">
            <i class="fe fe-check"></i>
            <span>{{ confirmText | translate }}</span>
        </ng-container>
    </button>
</div>